// extracted by mini-css-extract-plugin
export default {"infoIconWrapper":"InfoIcon_infoIconWrapper__5RWS2","infoIcon":"InfoIcon_infoIcon__FZjdh","tooltipBubble":"InfoIcon_tooltipBubble__Rj0cg"};